export default function RewardsCoupons() {
  return (
    <div className="space-y-2">
      <p className="text-sm font-medium text-green-700">Perk Point</p>
      <h1 className="text-2xl font-bold tracking-tight text-slate-900">
        Coupons
      </h1>
    </div>
  );
}
